import { usePartners, useWalletsBalanceWrapper } from '@capsicum/socios-core';
import { useCallback, useMemo, useState } from 'react';

import { useParticipationRequirement } from './useParticipationRequirement';

type UseParticipationGuardRendererProps = {
	partnerId: string;
	tokensRequired: number;
};

export const useParticipationGuardRenderer = ({ partnerId, tokensRequired }: UseParticipationGuardRendererProps) => {
	const { getPartnerBy } = usePartners();
	const [isVisibile, setVisibility] = useState(false);
	const { requirement } = useParticipationRequirement();
	const { hasEnoughBalance, hasEnoughStaked } = useWalletsBalanceWrapper({ isStakable: true });
	const partner = useMemo(() => getPartnerBy(p => p.id === partnerId), [getPartnerBy, partnerId]);

	tokensRequired = Number(tokensRequired);
	const partnerCurrencyID = partner?.currencyId || '';

	const hasEnoughTokens = useMemo(
		() =>
			requirement === 'STAKED'
				? hasEnoughStaked(partnerCurrencyID, tokensRequired)
				: hasEnoughBalance(partnerCurrencyID, tokensRequired),
		[requirement, tokensRequired, hasEnoughStaked, hasEnoughBalance, partnerCurrencyID]
	);

	const onDone = useCallback(() => setVisibility(false), []);

	return {
		hasEnoughTokens,
		isVisibile,
		onDone,
		setVisibility
	};
};
